import React, {Fragment} from 'react';

import CollapsibleOutcomeReviewHistory from "./CollapsibleOutcomeReviewHistory";

import UserInput from "../UI/ReactUserInput";
import UserInputTextarea from "../UI/ReactUserInputTextarea";
import ReactTooltip from "react-tooltip";
import {createOutcome, updateOutcome} from "root/DataFunctions/OutcomeDataFns";
import {getInsertIdFromResponse} from "root/DataFunctions/BaseDataFns";

import DropdownAchievementGroups2 from 'root/ReactHookForm/ui/DropdownAchievementGroups' ;

import { Base64 } from 'js-base64' ;
import ErrorDiv from "root/ReactHookForm/FormComponents/ErrorDiv";

export default class ChildOutcomesTableRowReviewOnly2 extends React.Component
{
	static get defaultProps() 
	{
	    return ({
		    	  id: 'collapse1',
		    	  title: 'Click to open'
	    	}) ;
	}
	  
	constructor(props) 
	{
		super(props);

		const data = this.props.data == null ? this.getEmptyData() : this.props.data ;

		const initGroup = this.props.data == null ? null : +data.achievement_group_id  ;

    	// Create a state item here for all items on the form  (Using their id )
		this.state = {
			title: this.props.title,
			forceOpen: false ,
			mode: this.props.mode,
			data: data,
		    buttonState: '',
			achievement_group_id: initGroup,
			};

		this.onModifyClick = this.onModifyClick.bind(this) ;
		this.onDeleteClick = this.onDeleteClick.bind(this) ;
		this.onCancelEditClick = this.onCancelEditClick.bind(this) ;

		this.onSaveChanges = this.onSaveChanges.bind(this) ;
		this.onSaveNew = this.onSaveNew.bind(this) ;
		this.onServiceChange = this.onServiceChange.bind(this) ;
		this.doUpdateUI = this.doUpdateUI.bind(this) ;
		this.doUpdateUIAfterAdd = this.doUpdateUIAfterAdd.bind(this) ;
		this.onMarkAchievedClick = this.onMarkAchievedClick.bind(this);
		this.updateTargetRecord = this.updateTargetRecord.bind(this);
	}

	componentDidUpdate()
	{
		ReactTooltip.rebuild();
	}

	getEmptyData()
	{
		let dataItem = {} ;

		dataItem.outcome_review_id = null ;
		dataItem.review_comment = null;

		dataItem.description = '';
		dataItem.action_and_provision = null;

		dataItem.actual_outcome = null;

		dataItem.cpp_date_created = '';
		dataItem.closed_flag = 0;

		dataItem.achievement_group_id = null;
		dataItem.date_set = null;
		dataItem.dmy_date_set = '';

		dataItem.target_date = null;
		dataItem.dmy_target_date = null;

		dataItem.ofr_id = this.props.ofr == null ? null : this.props.ofr.ofr_id ;

		dataItem.date_achieved = null ;
		dataItem.dmy_date_achieved = null ;
		dataItem.achievement_group_desc = null ;

		dataItem.agreed_with_head_flag = 0 ;

		dataItem.cpp_id = null ;

		return dataItem ;
	}

	doUpdateUI ( updateData )
	{
		this.setState ( { data: updateData, mode: this.props.mode }) ;
	}

	passup( rec )
	{
		this.props.onAddComplete ( rec ) ;
	}

	doUpdateUIAfterAdd ( updateData )
	{
		this.setState ( { data: updateData, mode: this.props.mode }, this.passup ( updateData )) ;
	}

	// This function creates the review record structure from the child's template and returns the data
	// created ready to e displayed on the forms
	updateTargetRecord ( updateData, operation )
	{
		const data = { plan_data: updateData } ;

		updateOutcome( this.props.child_id, updateData.cpp_id, data, this.props.authToken, (response) =>
		{
			const doUpdateUI = this.doUpdateUI ;
			const onDelFunc = this.props.onDelete;
			const delid = updateData.cpp_id;
			const op = operation ;
			const d = updateData ;

			bootbox.alert({
				size: "large",
				title: "Operation completed",
				message: "The record has been saved. Click OK to continue.",
				callback: function()
				{
					if ( op == 'close')
					{
						if ( onDelFunc != null )
						{
							onDelFunc ( delid ) ;
						}
					}
					else
					{
						if ( op == 'modify')
						{
							doUpdateUI ( updateData );
						}
					}

				}
			})
		}) ;
	}

	// This function creates the review record structure from the child's template and returns the data
	// created ready to e displayed on the forms
	createNewRecord ( newRecord )
	{
		const postData = { data: newRecord } ;

		createOutcome( newRecord.child_id, postData, this.props.authToken, (response) =>
		{
			let rec = newRecord ;

			const doUpdateUI = this.doUpdateUIAfterAdd ;

			rec.cpp_id = getInsertIdFromResponse( response ) ;

			bootbox.alert({
				size: "large",
				title: "Operation completed",
				message: "The target has been saved. Click OK to return.",
				callback: function()
				{
					doUpdateUI ( rec );
				}
			})
		})
	}

	doEncode ( value )
	{
		return value == null ? null : Base64.encode ( value ) ;
	}

	getFormData()
	{
		var dataItem = {} ;

		if ( this.props.ofr != null )
		{
			dataItem.outcome_review_id = this.state.data.outcome_review_id ;

			if ( this.state.mode === 'create' && this.reviewStatus() === OFR_STATUS_APPROVED )
			{
				dataItem.review_comment = null ;
				dataItem.review_commentBase64 = null ;
			}
			else if ( this.state.mode === 'modify' && this.reviewStatus() === OFR_STATUS_APPROVED )
			{
				// Preserve any existing comment
				dataItem.review_comment = this.props.data.review_comment ;
				dataItem.review_commentBase64 = this.doEncode ( dataItem.review_comment ) ;
			}
			else
			{
				dataItem.review_comment = this.refs.InputTermReviewComment.getValue() ;
				dataItem.review_commentBase64 = this.doEncode ( dataItem.review_comment )	;
			}
		}

		dataItem.description = this.refs.InputSupportDescription.getValue() ;
		dataItem.descriptionBase64 = this.doEncode ( dataItem.description ) ;

		dataItem.action_and_provision = this.refs.InputActionAndProvision.getValue() ;
		dataItem.action_and_provisionBase64 = this.doEncode (  dataItem.action_and_provision )	;

		dataItem.actual_outcome = this.refs.InputActualOutcome.getValue() ;
		dataItem.actual_outcomeBase64 =this.doEncode (  dataItem.actual_outcome )	;

		dataItem.cpp_date_created = this.state.data.cpp_date_created ;

		if ( this.state.mode === 'close')
		{
			dataItem.closed_flag = 1;
			dataItem.closed_flag = this.state.data.closed_flag;
			dataItem.dmy_date_achieved = this.refs.InputDateAchieved.getValue()  ;
		}
		else
		{
			dataItem.date_achieved = null ;
			dataItem.dmy_date_achieved = null ;
		}

		dataItem.achievement_group_id = this.state.achievement_group_id ;
		dataItem.date_set = this.refs.InputProgressPlanDateFrom.getValue();
		dataItem.dmy_date_set = this.refs.InputProgressPlanDateFrom.getValue();

		let de = this.refs.InputTargetDate.getValue() ;

		if ( de != null )
		{
			if ( de.length == 0 )
			{
				de = null ;
			}
		}

		dataItem.target_date = de;
		dataItem.dmy_target_date = de;

		dataItem.ppplus_flag = 'N' ;
		dataItem.intended_spend = null ;
		dataItem.actual_spend = null;

		dataItem.ofr_id = this.state.data.ofr_id ;

		dataItem.achievement_group_desc = this.state.data.achievement_group_desc ;

		dataItem.agreed_with_head_flag = 1 ;

		dataItem.cpp_id = this.state.data.cpp_id ;

		return dataItem ;
	}

	isFormValid ()
	{
		var i = 0 ;

		// Iterate through all the child controls to test each is reporting itself valid
		for (var key in this.refs)
		{
			var obj = this.refs[key] ;

			if ( typeof obj.isValid === 'function' )
			{
				if ( !obj.isValid())
				{
					return false ;
				}
			}
		}

		if ( this.state.achievement_group_id === null )
		{
			return false ;
		}

		return true ;
	}

	onSaveChanges()
	{
		if ( this.isFormValid())
		{
			const formData = this.getFormData() ;

			this.updateTargetRecord ( formData, 'modify' ) ;
		}
		else
		{
			this.setState ( { displayErrors: true }) ;
		}
	}

	onSaveNew()
	{
		if ( this.isFormValid())
		{
			const formData = this.getFormData() ;

			formData.child_id = this.props.child_id ;

			this.createNewRecord ( formData ) ;
		}
		else
		{
			this.setState ( { displayErrors: true }) ;
		}
	}

	disableButtons()
	{
		this.setState ( { buttonState: 'disabled'}) ;
	}
	
	enableButtons()
	{
		this.setState ( { buttonState: ''}) ;
	}

	hyperlink ( label, link )
	{
		return React.createElement ( 'a', { href: link, onClick: this.props.onCloseClick } , label ) ;
	}

	onModifyClick()
	{
		this.setState ( { mode: 'modify'}) ;
	}

	onCancelEditClick( e )
	{
		e.preventDefault() ;

		if ( this.props.mode === 'create')
		{
			this.props.onCancel();
		}
		else
		{
			this.setState ( { mode: this.props.mode}) ;
		}
	}

	hyperlinkEdit ( id )
	{
		return 	React.createElement ( 'a', { key: 'ModifyAnchor' + id, 'data-toggle' : 'collapse', onClick: this.onModifyClick, href: '#'+id} ,
				React.createElement ('span', { key: 'AnchorSpan' + id, 'data-tip' : "Edit", className: 'glyphicon glyphicon-pencil', style: { color: 'rgb(48,93,181)', marginRight: '10px'}})) ;
	}

	onClose()
	{
		let self = this ;

		bootbox.confirm({
			title: "Mark Target as Achieved?",
			message: "Are you sure you wish to close this target and mark it as ACHIEVED?",
			buttons: {
				cancel: {
					label: '<i class="fa fa-times"></i> Cancel'
				},
				confirm: {
					label: '<i class="fa fa-check"></i> Confirm Delete'
				}
			},
			callback: function (result)
			{
				if ( result == true )
				{
					self.props.onDelete ( self.props.data.cpp_id ) ;
				}
			}
		});
	}

	onMarkAchievedClick()
	{
		this.setState ( { mode: 'close'}) ;
	}

	hyperlinkMarkAchieved ( id )
	{
		return 	React.createElement ( 'a', { key: 'ModifyAchievedAnchor' + id, 'data-toggle' : 'collapse', onClick: this.onMarkAchievedClick, href: '#'+id} ,
			React.createElement ('span', { key: 'ModifyAchievedAnchorSpan' + id, 'data-tip' : "Mark Achieved", className: 'glyphicon glyphicon-check', style: { color: 'rgb(109, 181, 139)', marginRight: '10px'}})) ;
	}

	onDeleteClick( recordId )
	{
		let self = this ;

		bootbox.confirm({
			title: "Delete Target?",
			message: "Are you sure you wish to DELETE this target?",
			buttons: {
				cancel: {
					label: '<i class="fa fa-times"></i> Cancel'
				},
				confirm: {
					label: '<i class="fa fa-check"></i> Confirm Delete'
				}
			},
			callback: function (result)
			{
				if ( result == true )
				{
					self.props.onDelete ( self.props.data.cpp_id ) ;
				}
			}
		});
	}

	hyperlinkDelete ( id )
	{
		return (
			<a key={'DeleteAchievedAnchor' + id} onClick={this.onDeleteClick} href='#'>
				<span key={'DeleteAchievedAnchorSpan' + id} data-tip="Delete" className='glyphicon glyphicon-trash' style={{ color: '#d9534f', marginRight: '10px'}}></span>
			</a>
		)
	}

	hyperlinkCancelEdit ( id )
	{
		return React.createElement ( 'a', { key: 'CancelAchievedAnchor' + id, onClick: this.onCancelEditClick, href: '#' } ,
			React.createElement ('span', { key: 'CancelAchievedAnchorSpan' + id, 'data-tip' : "Cancel Edit", className: 'glyphicon glyphicon-ban-circle', style: { color: '#d9534f', marginRight: '10px'}})) ;
	}

	optionalCellDisplay ( value, cname, message )
	{
		if ( value === null || value === '' )
		{
			return React.createElement('div', {key:this.keyCount++, className: 'col-md-12 otr_cell_empty'}, message);
		}
		else
		{
			return React.createElement('div', {key:this.keyCount++, className: 'col-md-12 ' + cname }, value);
		}
	}

	outcomeDetailCell ( row )
	{
		let lineList = [] ;

		if ( row.dmy_date_achieved == null )
		{
			// Only display review details if the outcome is still ongoing
			if ( this.props.ofr != null )
			{
				if ( row.review_comment != null)
				{
					const comment = this.reviewStatus() === 4 ? 'Latest Teacher Review Comment (Approved)' : 'Latest Teacher Review Comment' ;

					lineList.push (
						<Fragment>
							<div key='commentDiv' className='col-md-8 otr_header_review'>{comment}</div>
							<div key='commentDivIcon' className='col-md-4'>{this.iconComplete(row.cpp_id)}</div>
							{ this.optionalCellDisplay ( row.review_comment, 'otr_review', "No review comment has been entered yet." )}
						</Fragment>
					)
				}
				else
				{
					const comment = ( this.reviewStatus() === 2 || this.reviewStatus() === 4 ) ? 'Latest Teacher Review Comment (Approved)' : 'Teacher Review Comment (Action Required)' ;

					lineList.push (
						<Fragment>
							<div key='commentDiv' className='col-md-8 otr_header_review'>{comment}</div>
							<div key='commentDivIcon' className='col-md-4'>{this.iconComplete(row.cpp_id)}</div>
							{ this.optionalCellDisplay ( row.review_comment, 'otr_review', "No review comment has been entered yet." )}
						</Fragment>
					)
				}
			}
			else
			{
				if ( row.review_comment != null )
				{
					const comment = 'Latest Teacher Review Comment (Approved)' ;

					lineList.push (
						<Fragment>
							<div key='commentDiv' className='col-md-8 otr_header_review'>{comment}</div>
							<div key='commentDivIcon' className='col-md-4'>{this.iconComplete(row.cpp_id)}</div>
							{ this.optionalCellDisplay ( row.review_comment, 'otr_review', "No review comment has been entered yet." )}
						</Fragment>
					)
				}
			}
		}
		else
		{
			if ( row.review_comment != null)
			{
				if ( this.reviewStatus() === 4 )
				{
					lineList.push (
						<Fragment>
							<div key='commentDiv' className='col-md-8 otr_header_review'>Latest Teacher Review Comment (Approved)</div>
							<div key='commentDivIcon' className='col-md-4'>{this.iconComplete(row.cpp_id)}</div>
							{ this.optionalCellDisplay ( row.review_comment, 'otr_review', row.review_comment )}
						</Fragment>
					)
				}
				else
				{
					lineList.push (
						<Fragment>
							<div key='commentDiv' className='col-md-8 otr_header_review'>Latest Teacher Review Comment</div>
							<div key='commentDivIcon' className='col-md-4'>{this.iconComplete(row.cpp_id)}</div>
							{ this.optionalCellDisplay ( row.review_comment, 'otr_review', row.review_comment )}
						</Fragment>
					)
				}
			}
		}

		let data = row.review_history == null ? [] : row.review_history ;

		let cellTitle = 'Target' ;

		if ( row.achievement_group_desc !== 'Attendance' && this.props.isSen === true )
		{
			cellTitle += ' (Aligned with EHCP)' ;
		}

		lineList.push (
			<Fragment key={'frag1'}>
				<div key='AchievementLabelDiv' className='col-md-4 otr_header'>Achievement Group</div>
				<div key='AchievementDiv' className='col-md-8 otr_cell' style={{textAlign: 'end'}}>{row.achievement_group_desc}</div>
				<div key='OutcomeLabelDiv' className='col-md-12 otr_header'>{cellTitle}</div>
				{ this.optionalCellDisplay ( row.description, 'otr_cell', "No outcome has been entered yet." )}
				<div key='ActionLabelDiv' className='col-md-12 otr_header'>Action and Provision Required</div>
				{ this.optionalCellDisplay ( row.action_and_provision, 'otr_cell', "No outcome has been entered yet." )}
				<div key='ActualLabelDiv' className='col-md-12 otr_header'>Outcome (Final Review)</div>
				{ this.optionalCellDisplay ( row.actual_outcome, 'otr_cell', "No outcome has been entered yet." )}
				<div key='DateSetLabelDiv' className='col-md-6 otr_header'>Date Set</div>
				<div key='DateSetLabelDiv1' className='col-md-6 otr_header'>Target Date</div>
				<div key='DateSetLabelDiv2' className='col-md-6 otr_cell'>{row.dmy_date_set}</div>
				<div key='DateSetLabelDiv3' className='col-md-6 otr_cell'>{row.dmy_target_date}</div>
				<div key='Hist' className='col-md-12'>
					<CollapsibleOutcomeReviewHistory cpp_id={row.cpp_id} data={data} />
				</div>
			</Fragment>
		)

		return lineList ;
	}

	rowButtons()
	{
		switch ( this.state.mode )
		{
			case 'create':
				return (
					<div className='col-md-12'>
						<div key='bb1' className='col-md-6'></div>
						<div key='bcon' className='col-md-6' style={{paddingRight: '0px'}}>
							<button key='b1' type='button' className='btn btn-primary' style={{marginTop: '10px', float: 'right'}} onClick={this.onSaveNew}>Save Target</button>
							<button key='b2' type='button' className='btn btn-secondary' style={{marginTop: '10px', float: 'right', marginRight: '10px'}} onClick={this.onCancelEditClick}>Cancel</button>
						</div>
					</div>
				);
			case 'modify':
				return (
					<div className='col-md-12'>
						<div key='bb1' className='col-md-6'></div>
						<div key='bcon1' className='col-md-6' style={{ paddingRight: '0px'}}>
							<button key='b3' type='button' className='btn btn-primary' style={{ marginTop: '10px', float: 'right' }} onClick={this.onSaveChanges}>Save Changes</button>
							<button key='b4' type='button' className='btn btn-secondary' style={{ marginTop: '10px', float: 'right', marginRight: '10px' }} onClick={this.onCancelEditClick}>Cancel</button>
						</div>
					</div>
				);
			case 'close':
				return (
					<div className='col-md-12'>
						<div key='bb1' className='col-md-6'></div>
						<div key='bcon2' className='col-md-6' style={{ paddingRight: '0px'}}>
							<button key='b5' type='button' className='btn btn-primary' style={{ marginTop: '10px', float: 'right' }} onClick={this.onSaveChanges}>Mark Completed</button>
							<button key='b6' type='button' className='btn btn-secondary' style={{ marginTop: '10px', float: 'right', marginRight: '10px' }} onClick={this.onCancelEditClick}>Cancel</button>
						</div>
					</div>
				);
		}
	}

	onServiceChange ( serviceobj )
	{
		let oldData = this.state.data ;

		oldData.achievement_group_id = serviceobj.value ;
		oldData.achievement_group_desc = serviceobj.label;

		this.setState ( { data: oldData, achievement_group_id: serviceobj.value });
	}

	reviewStatus()
	{
		if ( this.props.ofr != null )
		{
			return +this.props.ofr.status ;
		}
		else
		{
			return null ;
		}
	}

	iconComplete ( id )
	{
		return 	React.createElement ('span', { key: 'doneIcon' + id, className: 'glyphicon glyphicon-ok', style: { float: 'right', color: 'rgb(109, 181, 139)', marginRight: '10px'}}) ;
	}

	iconIncomplete ( id )
	{
		return 	React.createElement ('span', { key: 'notDonIcon' + id, className: 'glyphicon glyphicon-warning-sign', style: { float: 'right', color: '#eac02f', marginRight: '10px'}}) ;
	}

	getFormattedDate(date)
	{
		var year = date.getFullYear();
		var month = (1 + date.getMonth()).toString();
		month = month.length > 1 ? month : '0' + month;
		var day = date.getDate().toString();
		day = day.length > 1 ? day : '0' + day;
		return day + '/' + month + '/' + year;
	}

	outcomeDetailCellEditable ( row )
	{
		let lineList = [] ;

		if ( this.props.mode === 'create')
		{
			lineList.push(React.createElement('div', {key:this.keyCount++, className: 'col-md-12 otr_title'}, "Add a new Target"));

			if (this.props.ofr != null && this.reviewStatus() !== 4) /* Not Approved */
			{
				let textStyle = { fontSize: '14px', fontWeight: 'normal', paddingLeft: '15px', paddingRight: '15px', marginBottom: '0px', color: '#a94442' } ;

				const text = "As this is within a review period, please enter a comment." ;
				lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;

				lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-md-12'},
					React.createElement ( UserInputTextarea, {
						validation: { required: true, maxlen: 2000 },
						rows: 3,
						id: 'InputTermReviewComment',
						name: 'InputTermReviewComment',
						ref: 'InputTermReviewComment',
						label: 'Review Comment',
						errorText: 'Please enter a review comment',
						value: row.review_comment,
						tabIndex: 1,
						readOnly: false,
						displayErrors:this.state.displayErrors,
						key: this.keyCount++
					}))) ;
			}
		}
		else if ( this.state.mode === 'close' )
		{
			if (this.props.ofr != null)
			{
				let textStyle = { fontSize: '14px', fontWeight: 'normal', paddingLeft: '15px', paddingRight: '15px', marginBottom: '0px', color: '#a94442' } ;

				let text = "Please enter review comment for this Target before you close it." ;
				lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;

				lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-md-12'},
					React.createElement ( UserInputTextarea, {
						validation: { required: true, maxlen: 2000 },
						rows: 3,
						id: 'InputTermReviewComment',
						name: 'InputTermReviewComment',
						ref: 'InputTermReviewComment',
						label: 'Review Comment',
						errorText: 'Please enter a review comment',
						value: row.review_comment,
						tabIndex: 1,
						readOnly: false,
						displayErrors:this.state.displayErrors,
						key: this.keyCount++
					}))) ;
			}
		}
		else if ( this.props.ofr != null && row.dmy_date_achieved == null  && this.reviewStatus() != OFR_STATUS_APPROVED )
		{
			let textStyle = { fontSize: '14px', fontWeight: 'normal', paddingLeft: '15px', paddingRight: '15px', marginBottom: '0px', color: '#a94442' } ;

			let text = "Please review this target, ensuring that it is valid and up-to-date, then enter a short comment below summarising the pupil's progress this term." ;
			lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;

			lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-md-12'},
				React.createElement ( UserInputTextarea, {
					validation: { required: true, maxlen: 2000 },
					rows: 3,
					id: 'InputTermReviewComment',
					name: 'InputTermReviewComment',
					ref: 'InputTermReviewComment',
					label: 'Review Comment',
					errorText: 'Please enter a review comment',
					value: row.review_comment,
					tabIndex: 1,
					readOnly: false,
					displayErrors:this.state.displayErrors,
					key: this.keyCount++
				}))) ;
		}
		else
		{
			if (  this.props.ofr != null )
			{
				// If it has been approved, but no comments was entered, we need to show approved
				// ( This can occur because we set all the outcomes to 'approved' manually without requiring the teacher to enter a comment. )
				if ( row.review_comment != null || this.reviewStatus() == OFR_STATUS_APPROVED )
				{
					lineList.push(React.createElement('div', {key:this.keyCount++, className: 'col-md-8 otr_header_review'}, "Latest Teacher Review Comment (Approved)"));
					lineList.push(React.createElement('div', {key:this.keyCount++, className: 'col-md-4'}, this.iconComplete(row.cpp_id)));
				}
				else
				{
					lineList.push(React.createElement('div', {key:this.keyCount++, className: 'col-md-8 otr_header_review'}, "Latest Teacher Review Comment (Action Required)"));
					lineList.push(React.createElement('div', {key:this.keyCount++, className: 'col-md-4'}, this.iconIncomplete(row.cpp_id)));
				}

				lineList.push(React.createElement('div', {key:this.keyCount++, className: 'col-md-12 otr_review'}, row.review_comment));
			}
		}

		if ( this.state.mode === 'close' )
		{

			lineList.push (React.createElement ( 'div', { key:'ActualContentDiv', className: 'col-md-12'},
				React.createElement ( UserInputTextarea, {
					validation: { required: true, maxlen: 2000 },
					rows: 3,
					autofocus: true,
					id: 'InputActualOutcome',
					label: 'Outcome',
					name: 'InputActualOutcome',
					ref: 'InputActualOutcome',
					errorText: 'Valid text required',
					value: row.actual_outcome,
					tabIndex: 2,
					readOnly: false,
					displayErrors:this.state.displayErrors,
					key: 'InputActualOutcome'
				}))) ;

			lineList.push ( React.createElement('div',  {key: 'DateAchievedValueColDiv', className: 'col-md-12'},
				React.createElement ( UserInput, { validation: { required: true, maxlen: 10, isDate: true },
					id: 'InputDateAchieved',
					name: 'InputDateAchieved',
					ref: 'InputDateAchieved',
					labelText: 'Date Achieved',
					errorText: 'You must enter a valid date',
					value: this.getFormattedDate ( new Date()),
					tabIndex: 3,
					readOnly: false,
					displayErrors:this.state.displayErrors,
					key: 'DateAchievedValueDiv'
				}))) ;

			lineList.push(React.createElement('div', {key:'DateAchievedValueDiv', className: 'col-md-12 otr_cell'}, row.dmy_date_achieved));
		}

		lineList.push (
			<div className='col-md-12' style={{marginTop: '10px'}}>
				<DropdownAchievementGroups2 isPost16={this.props.isPost16} onChange={this.onServiceChange} initialValue={{value: +row.achievement_group_id}} />
				{ (this.state.displayErrors === true && this.state.achievement_group_id === null) && <ErrorDiv>Please select an achievement area</ErrorDiv> }
			</div>
		)

		/* lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-md-12'},
			React.createElement ( DropdownAchievementGroups, {
				validation: { required: true},
				mode: 'list',
				id: 'InputAchievementGroup',
				ref: 'InputAchievementGroup',
				name: 'InputAchievementGroup',
				labelText: 'Select an outcome group',
				errorText: 'You must select an outcome group',
				defaultValue: row.achievement_group_id,
				tabIndex: 4,
				readOnly: false,
				isPost16: this.props.isPost16,
				displayErrors:this.state.displayErrors,
				key: 'InputAchievementGroup',
				onChange: this.onServiceChange
			}))) ; */

		let cellTitle = 'Target' ;

		if ( row.achievement_group_desc !== 'Attendance' && this.props.isSen === true )
		{
			cellTitle += ' (Aligned with EHCP)' ;
		}

		/*lineList.push(
			<div className='col-md-12 otr_header otr_spacer' style={{color: 'rgb(105, 161, 210)'}}>{cellTitle}</div>
		) */

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-md-12'},
			React.createElement ( UserInputTextarea, {
				validation: { required: true, maxlen: 2000 },
				rows: 3,
				id: 'InputSupportDescription',
				name: 'InputSupportDescription',
				ref: 'InputSupportDescription',
				errorText: 'Valid text required',
				value: row.description,
				label: cellTitle,
				tabIndex: 5,
				readOnly: false,
				displayErrors:this.state.displayErrors,
				key: 'InputSupportDescription'
			}))) ;

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-md-12'},
			React.createElement ( UserInputTextarea, {
				validation: { required: false, maxlen: 2000 },
				rows: 3,
				id: 'InputActionAndProvision',
				name: 'InputActionAndProvision',
				ref: 'InputActionAndProvision',
				errorText: 'Valid text required',
				label: "Action and Provision Required",
				value: row.action_and_provision,
				tabIndex: 6,
				readOnly: false,
				displayErrors:this.state.displayErrors,
				key: 'InputActionAndProvision'
			}))) ;

		if ( this.state.mode !== 'close' )
		{
			lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-md-12'},
				React.createElement ( UserInputTextarea, {
					validation: { required: false, maxlen: 2000 },
					rows: 3,
					id: 'InputActualOutcome',
					name: 'InputActualOutcome',
					ref: 'InputActualOutcome',
					errorText: 'Valid text required',
					label: 'Outcome (Final Review)',
					value: row.actual_outcome,
					tabIndex: 7,
					readOnly: false,
					displayErrors:this.state.displayErrors,
					key: 'InputActualOutcome'
				}))) ;
		}

		let d = this.state.data.dmy_date_set ;
		let d2 = this.state.data.dmy_target_date ;

		if ( this.props.mode === 'create' )
		{
			let now = new Date() ;
			let sixMonthsHence = new Date();
			sixMonthsHence.setMonth(sixMonthsHence.getMonth() + 6);

			d = this.getFormattedDate ( now );
			d2 = this.getFormattedDate (sixMonthsHence) ;
		}

		lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
			React.createElement ( UserInput, { validation: { required: true, maxlen: 10, isDate: true },
				id: 'InputProgressPlanDateFrom',
				name: 'InputProgressPlanDateFrom',
				ref: 'InputProgressPlanDateFrom',
				labelText: 'Date Set',
				errorText: 'You must enter a valid date',
				value: d,
				tabIndex: 8,
				readOnly: false,
				displayErrors:this.state.displayErrors,
				key: 'InputProgressPlanDateFrom'
			}))) ;

		const dateErrorText = this.state.formErrorState == 1 ? "Target date must be after 'Date From'" : "You must enter a valid date";

		lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
			React.createElement ( UserInput, { validation: { required: false, maxlen: 10, isDate: true },
				id: 'InputTargetDate',
				name: 'InputTargetDate',
				ref: 'InputTargetDate',
				labelText: 'Target Date',
				errorText: dateErrorText,
				value: d2,
				tabIndex: 9,
				readOnly: false,
				displayErrors:this.state.displayErrors,
				key: 'InputTargetDate'
			}))) ;

		if ( this.props.mode != 'create')
		{
			const data = row.review_history == null ? [] : row.review_history ;

			lineList.push(React.createElement('div', {key:this.keyCount++, className: 'col-md-12'},
				React.createElement ( CollapsibleOutcomeReviewHistory, { cpp_id: row.cpp_id, data: data } )));
		}

		lineList.push ( this.rowButtons());

		return lineList ;
	}

	actions ( row )
	{
		let lineList = [] ;

		switch ( this.state.mode )
		{
			case 'edit' :
				if (row.dmy_date_achieved == null)
				{
					if ( this.props.allowChange === true )
					{
						lineList.push( this.hyperlinkEdit(row.cpp_id) );
					}
				}

				if (row.dmy_date_achieved == null)
				{
					if ( this.props.allowChange === true )
					{
						lineList.push(this.hyperlinkMarkAchieved(row.cpp_id));
					}
				}

				if ( this.props.allowChange === true )
				{
					lineList.push( this.hyperlinkDelete(row.cpp_id) );
				}

				break;
			case 'qa' :
				if (row.dmy_date_achieved == null)
				{
					if ( this.props.allowChange === true )
					{
						lineList.push( this.hyperlinkEdit(row.cpp_id) );
					}
				}

				if (row.dmy_date_achieved == null)
				{
					if ( this.props.allowChange === true )
					{
						lineList.push(this.hyperlinkMarkAchieved(row.cpp_id));
					}
				}

				if ( this.props.allowChange === true )
				{
					lineList.push( this.hyperlinkDelete(row.cpp_id) );
				}
				break;
			case 'modify' :

				lineList.push(this.hyperlinkCancelEdit(row.cpp_id));

				break;
		}

		return lineList ;
	}

	tableRow ( row )
	{
		const lineList = this.props.columns.map ( (value,index) => {

			if ( value.data_field === 'detail' )
			{
				const elements = this.state.mode === 'modify' || this.state.mode === 'create' || this.state.mode === 'close' ? this.outcomeDetailCellEditable(row) : this.outcomeDetailCell(row) ;

				return React.createElement('div', {
					key: index,
					className: value.className,
					style: value.style
				}, elements );
			}
			else if ( value.data_field === 'actions')
			{
				return React.createElement('div', {
					key: index,
					className: value.className,
					style: {}
				}, this.actions(row));
			}
			else
			{
				return <div key={index} className={value.className} style={{borderRightStyle: 'solid', borderRightColor: 'lightgrey', borderRightWidth: '1px'}}>{row[value.data_field]}</div>
			}
		});

		return React.createElement('div', {key:'cpp'+row.cpp_id, className: 'row', style: {padding: '10px'}}, lineList ) ;
	}

	collapsiblePanelHeading ()
	{
		return (
			<div key='PanelHeading' className='panel-heading-outcome' style={{ paddingTop: '5px', paddingBottom: '5px', color: '#69a1d2' }}>
				{ this.tableRow( this.state.data ) }
			</div>
		)
	}

	collapsiblePanelHeadingAndContent()
	{
		return this.collapsiblePanelHeading () ;
	}

	curID()
	{
		return this.props.data == null ? 'add' : this.props.data.cpp_id ;
	}

	collapsibleRow()
	{
		return (
			<div key={'PanelRow' + this.curID()} className='row'>
			<div className='col-md-12'>
				<div className={'panel-group'}>
					<div className='panel panel-default'>
						{this.collapsiblePanelHeadingAndContent() }
					</div>
				</div>
			</div>
		</div>
		)
	}

    render()
    {
    	this.keyCount = 0 ;

    	return this.collapsibleRow() ;    	
    }
};


